<template>
  <div class="px-2">
    <h3 class="display-1 font-weight-bold">Share</h3>
    <v-layout row>
      <v-flex xs4>
        <div @click="changeShareMethod('me')" class="btn-wrapper">
          <img class="mx-4 round-btn" :class="classMe" :src="require('../assets/user.svg')">
          <p class="subheading text-center">Me Only</p>
        </div>
      </v-flex>
      <v-flex xs4>
        <div @click="changeShareMethod('invite')" class="btn-wrapper">
          <img class="mx-4 round-btn" :class="classInvite" :src="require('../assets/email.svg')">
          <p class="subheading text-center">By Invitation</p>
        </div>
      </v-flex>
      <v-flex xs4>
        <div @click="changeShareMethod('public')" class="btn-wrapper">
          <img class="mx-4 round-btn" :class="classEveryone" :src="require('../assets/group.svg')">
          <p class="subheading text-center">Public</p>
        </div>
      </v-flex>
    </v-layout>
    <v-layout wrap v-if="share==='invite'">
      <v-flex class="px-2">
        <v-form v-model="valid" ref="shareForm">
          <v-select
              v-model="group"
              :items="groups"
              @click:prepend="loadItems"
              :prepend-icon="isItemError? 'refresh' : ''"
              :loading="isItemLoading"
              @focus="loadItems"
              :rules="[v => !!v || 'required']"
              label="Select Group"
          ></v-select>
        </v-form>
        <v-form v-model="groupValid" ref="groupForm" v-if="creatingNewGroup || editingExistingGroup">
          <v-text-field
              v-if="creatingNewGroup"
              label="Group Name"
              v-model="groupName"
              :rules="[v => !!v && v!=='New Group' || share!=='invite' || 'required']"
              required
          ></v-text-field>

          <v-combobox
              v-model="emails"
              label="Enter Email(s) or Phone Number(s), press enter or tab after each"
              hint="example@mail.com or 310-785-8822"
              :rules="emailRules"
              chips
              clearable
              multiple
              required
          >
            <template v-slot:selection="data">
              <v-chip
                  :selected="data.selected"
                  close
                  @input="remove(data.item)"
              >
                <strong>{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-combobox>
          <v-layout>
            <v-spacer></v-spacer>
            <v-btn v-if="creatingNewGroup" depressed round color="success" :disabled="!groupValid" @click="createGroup">
              Create New Group
            </v-btn>
            <v-btn v-if="isGroupModified" flat round color="success"  @click="resetGroup">
              reset
            </v-btn>
            <v-btn v-if="isGroupModified" depressed round color="success" :disabled="!groupValid" @click="editGroup">
              edit group
            </v-btn>
          </v-layout>

        </v-form>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-spacer></v-spacer>
    </v-layout>
  </div>
</template>

<script>
    import {createHelpers} from 'vuex-map-fields';
    import {mapGetters} from "vuex";
    import _ from 'lodash'

    const {mapFields} = createHelpers({
        getterType: 'instaplayForm/share/getShareField',
        mutationType: 'instaplayForm/share/updateShareField',
    });

    export default {
        name: "Share",
        data() {
            return {
                groupValid: false,
                groupName: '',
                emails: [],
                emailRules: [
                    () => this.share !== 'invite' || !!this.emails.length || 'required',
                    () => this.share !== 'invite' || this.areEmailsValid(this.emails) || 'enter valid emails or phone numbers (###-###-####)'
                ],
                itemsLoaded: false
            }
        },
        methods: {
            loadItems () {
                if (!this.itemsLoaded) {
                    this.$store.dispatch('instaplayForm/share/getEmailGroups')
                        .then(() => {
                            if (this.isItemSuccess)
                                this.itemsLoaded = true
                        })
                }
            },
            createGroup: function () {
                this.groups.push({
                    text: this.groupName,
                    value: {
                        name: this.groupName,
                        addresses: this.emails,
                        modified: true
                    }
                })
                this.$refs.groupForm.reset()
                this.group = this.groups[this.groups.length - 1].value
            },
            editGroup: function () {
                this.group.addresses = this.emails.concat()
                this.group.modified = true
            },
            resetGroup: function () {
                this.emails = this.group.addresses.concat()
                this.group.modified = false
            },
            changeShareMethod: function (share) {
                if (this.share === share) {
                    this.share = ''
                } else {
                    this.share = share
                }
            },
            areEmailsValid: function (emails) {
                for (let i = 0; i < emails.length; i++) {
                    if (!(/.+@.+/.test(emails[i])) &&  !(/\d{3}-\d{3}-\d{4}/.test(emails[i]))) {
                        return false
                    }
                }
                return true
            },
            remove(item) {
                this.emails.splice(this.emails.indexOf(item), 1)
                this.emails = [...this.emails]
            }
        },
        computed: {
            ...mapFields({share: 'privacy'}),
            ...mapFields(['groups', 'group']),
            ...mapGetters('instaplayForm', ['isItemLoading', 'isItemSuccess', 'isItemError']),
            valid: {
                get() {
                    if (this.share === 'invite')
                        return !!this.group && this.group !== 'New Group' && !this.isGroupModified
                    return !!this.share
                },
                set(newVal) {
                    return newVal && !!this.share
                }
            },
            classMe: function () {
                return {accent: this.share === 'me'}
            },
            classInvite: function () {
                return {accent: this.share === 'invite'}
            },
            classEveryone: function () {
                return {accent: this.share === 'public'}
            },
            creatingNewGroup: function () {
                return this.group === 'New Group'
            },
            editingExistingGroup: function () {
                return this.group && this.group !== 'New Group'
            },
            isGroupModified: function () {
                return this.editingExistingGroup && !_.isEqual(this.emails, this.group.addresses)
            }
        },
        watch: {
            group: function(val) {
                if (val.addresses)
                    this.emails = val.addresses.concat()
                else
                    this.emails = []
            },
            valid: function (val) {
                this.$emit('input', val)
            },
            share: function (val) {
                if (val === 'invite')
                    this.loadItems()
            }
        },
    }
</script>

<style scoped>
  .round-btn {
    border-radius: 50%;
    cursor: pointer;
    max-width: 50%;
  }

  .btn-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .text-center {
    text-align: center;
  }
</style>
